import { AfterViewInit, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';

import { Subscription } from 'rxjs';

import { AbstractFormFieldComponent } from '../../../PageBuilder/components/FormField/abstract-form-field.component';
import { DropdownOptionModel } from '../../../Forms/models/dropdown-option.model';
import { MonitoringAccountConfigurationApi } from '../../../../api/monitoring/monitoring-account-configuration.api';
import { ProminenceGroupPickerModel } from './prominence-group-picker.model';
import { ReportSeriesModel } from '../../models/report-series.model';
import { ProminenceGroupApiModel } from '../../../../api/monitoring/model/prominence-group-api.model';

@Component({
    selector: 'agpr-prominence-group-picker',
    templateUrl: './prominence-group-picker.component.html',
    styleUrls: ['./prominence-group-picker.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => ProminenceGroupPickerComponent)
        }
    ],
    standalone: false
})
export class ProminenceGroupPickerComponent extends AbstractFormFieldComponent implements AfterViewInit {

    subscriptions: Subscription[] = [];
    prominenceGroups: DropdownOptionModel<ProminenceGroupApiModel>[];
    selectedProminenceGroup: DropdownOptionModel<ProminenceGroupApiModel>;
    disabled: boolean = false;

    @Input() declare field: ProminenceGroupPickerModel;
    @Input() declare value: ReportSeriesModel[];
    @Output() changes: EventEmitter<ReportSeriesModel[]> = new EventEmitter<ReportSeriesModel[]>();

    constructor(
        private monitoringConfigApi: MonitoringAccountConfigurationApi
    ) {
        super();

        this.monitoringConfigApi.getProminenceGroups().subscribe(groups => {
            this.disabled = !groups || groups.length === 0;
            this.prominenceGroups = groups.map(group => {
                return new DropdownOptionModel(group.name, group);
            });
            this.setSelectedProminenceGroup();
        });
    }

    ngAfterViewInit() {
        this.setSelectedProminenceGroup();
    }

    setSelectedProminenceGroup() {
        if (this.value && this.prominenceGroups && this.prominenceGroups.length !== 0) {
            // All the series have the same group so we can just pick the first one
            if (this.value[0].prominenceTrendGroup) {
                this.selectedProminenceGroup = this.prominenceGroups.find(x => x.value.id === this.value[0].prominenceTrendGroup?.id);
            }
        }

        if (this.prominenceGroups && this.prominenceGroups.length === 0) {
            this.value.forEach(series => series.prominenceTrendGroup = null);
            this.changes.next(this.value.slice());
        }
    }

    setGroupId() {
        this.value.forEach(x => {
            x.prominenceTrendGroup = {
                id: this.selectedProminenceGroup.value.id,
                name: this.selectedProminenceGroup.label,
                keywords: this.selectedProminenceGroup.value.keywords
            };
        });
        this.changes.next(this.value.slice());
    }
}

